import React, { useState } from "react";

const FormSection = ({
  buttonLabel,
  paragraphText,
  inputPlaceholder,
  position,
  isEditable,
  onInputChange,
  onPositionChange,
}) => {
  return (
    <>
      <span className="d-flex align-items-center">
        <button style={{ flexShrink: 0 }}>{buttonLabel}</button>
        <p
          className="m-0 text-justify"
          style={{ paddingLeft: "1rem", flexGrow: 1 }}
        >
          {paragraphText}
        </p>
      </span>

      <br />

      <div className="d-flex justify-content-center align-items-center flex-column">
        <div className="d-flex w-100 justify-content-center align-items-flex-start">
          <div
            className="d-flex flex-column align-items-center"
            style={{ width: "48%" }}
          >
            <div
              className=""
              style={{
                border: "none",
                borderBottom: "1px solid #333",
                width: "100%",
                padding: "1px 0px",
              }}
            ></div>

            {isEditable ? (
              <>
                <input
                  type="text"
                  value={inputPlaceholder}
                  onChange={onInputChange}
                  placeholder="Enter name"
                  style={{
                    width: "100%",
                    fontWeight: "bold",
                    border: "none",
                    textAlign: "center",
                    margin: "0 0 10px 0",
                  }}
                />
                <input
                  type="text"
                  value={position}
                  onChange={onPositionChange}
                  placeholder="Enter position"
                  style={{ width: "100%", textAlign: "center", border: "none" }}
                />
              </>
            ) : (
              <>
                <p
                  className="m-0 text-center fs-6"
                  style={{ fontWeight: "bold" }}
                >
                  {inputPlaceholder}
                </p>
                <p className="m-0 text-center">{position}</p>
              </>
            )}
          </div>
          <div
            className="d-flex flex-column align-items-center"
            style={{ width: "40%", padding: "0px 1.5rem" }}
          >
            <div
              className=""
              style={{
                border: "none",
                borderBottom: "1px solid #333",
                width: "100%",
                padding: "1px 0px",
              }}
            ></div>

            <p className="m-0">Date</p>
          </div>
        </div>
      </div>
      <br />
    </>
  );
};

const FormFooter = ({ name, position, onNameChange, onPositionChange }) => {
  return (
    <div
      className="justify-content-center align-items-center mt-4 p-3"
      style={{ fontSize: "13px" }}
    >
      <div className="w-100" style={{ overflowX: "auto" }}>
        <div className="w-100 border" style={{ overflowX: "auto" }}>
          <div
            className="d-flex flex-row flex-wrap flex-md-nowrap"
            style={{ minWidth: "600px", border: "1px solid black" }}
          >
            <div className="d-flex flex-column flex-shrink-0 col-12 col-md-6 ">
              {/* Section 1 */}
              <FormSection
                buttonLabel="A"
                paragraphText="CERTIFIED: Services duly rendered as stated."
                inputPlaceholder="RHUBIE M. TAMAYO"
                position="Acting Chief, Compensation & Employee Benefits Unit"
              />

              {/* Section 2 */}
              <FormSection
                buttonLabel="B"
                paragraphText="CERTIFIED: Supporting documents complete and proper, and cash available in the amount of ₱ 0.00"
                inputPlaceholder="CHESTER KEVIN S. SY"
                position="Chief, Accounting Section"
              />
            </div>

            <div className="d-flex flex-column flex-shrink-0 col-12 col-md-6 border-start border-top">
              {/* Section 3 (Editable Section) */}
              <FormSection
                buttonLabel="C"
                paragraphText="Approved for Payment"
                inputPlaceholder={name}
                position={position}
                isEditable={true}
                onInputChange={(e) => onNameChange(e.target.value)}
                onPositionChange={(e) => onPositionChange(e.target.value)}
              />

              {/* Section 4 */}
              <FormSection
                buttonLabel="D"
                paragraphText="CERTIFIED: Each employee whose name appears above has been paid in the amount indicated opposite on his/her name."
                inputPlaceholder="LILIBETH F. LINTAG"
                position="Disbursing Officer"
              />
            </div>
          </div>
          <div
            className="d-flex flex-row"
            style={{
              minWidth: "600px",
              border: "1px solid black",
              borderTop: "none",
            }}
          >
            <div className="border-end " style={{ flex: 1 }}>
              <div className="p-2">
                <div>Remarks:</div>
                <div>Effectivity Date:</div>
                <div>Transferred:</div>
                <div>Newly Appointed:</div>
                <div>Promoted:</div>
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div className="p-2">
                <div>Order No:</div>
                <div>JEV No:</div>
                <div>Date:</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormFooter;
